import RecordAction from '../RecordAction';
import type ApplicationModel from 'components/framework/ApplicationModel';

export class SortChildPagesAction extends RecordAction {
  recordTypes = ['Page'];
  emptySubmenuContent = 'No options available';

  get title() {
    return 'Sort children by';
  }

  get icon() {
    return 'fa-regular fa-bars-sort';
  }

  get hasSubmenu() {
    return true;
  }

  async prepareSubmenuItems() {
    return [
      { label: 'Name', data: { sort: 'name' } },
      { label: 'Date created', data: { sort: 'createdAt' } },
    ];
  }

  showForRecord(record: ApplicationModel): record is ApplicationModel {
    return (
      super.showForRecord(record) &&
      'childrenCount' in record &&
      typeof record.childrenCount === 'number' &&
      record.childrenCount > 1
    );
  }

  async runForRecords(records, { sort }) {
    if (!sort) return;
    await Promise.all(records.map(record => record.sortChildren({ sort })));
  }
}
